module.exports = __webpack_public_path__ + "img/26_156.97aa1115.png";